import { WebinarRequestContext } from 'contexts/WebinarContext';
import { useContext } from 'react';

export const useWebinarRequest = () => {
  const context = useContext(WebinarRequestContext);
  if (!context) {
    throw new Error('useWebRequest must be used within a WebRequestContext');
  }
  return context;
};
